import { useEffect, useState } from 'react';

import { LOCAL_STORAGE_KEY } from '../constants/localStorage';
import localStorageService from '../helpers/localStorageService';

export const useSoundEnabled = () => {
  const [isSoundEnabled, setIsSoundEnabled] = useState<boolean>(() => {
    const stored = localStorageService.get<string>(LOCAL_STORAGE_KEY.SOUND_ENABLED);
    return stored === null ? false : stored === 'true';
  });

  useEffect(() => {
    localStorageService.set(LOCAL_STORAGE_KEY.SOUND_ENABLED, String(isSoundEnabled));
  }, [isSoundEnabled]);

  const toggleSound = () => {
    setIsSoundEnabled(prev => !prev);
  };

  return {
    isSoundEnabled,
    toggleSound
  };
}; 
